import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { DropdownMenuContent } from './DropdownMenuContent';
import { type DropdownMenuItemProps } from './DropdownMenuItem';
import { DropdownMenuTrigger } from './DropdownMenuTrigger';

export interface DropdownMenuProps extends RadixDropdownMenu.DropdownMenuProps {
  items: (DropdownMenuItemProps | JSX.Element)[];
  side?: RadixDropdownMenu.DropdownMenuContentProps['side'];
  onSelect?: (id: string) => void;
}

export const DropdownMenu = ({ items, side, onSelect, children, ...props }: DropdownMenuProps) => (
  <RadixDropdownMenu.Root modal={false} {...props}>
    <DropdownMenuTrigger>{children}</DropdownMenuTrigger>
    <RadixDropdownMenu.Portal>
      <DropdownMenuContent items={items} side={side} onSelect={onSelect} />
    </RadixDropdownMenu.Portal>
  </RadixDropdownMenu.Root>
);
